import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import DArrow from 'src/assets/icons/DArrow';
import FilterIcon from 'src/assets/icons/FilterIcon';
import Popover from '@mui/material/Popover';
import DownChevron from 'src/assets/icons/DownChevron';
import Tabs from './tabs';
import useApi from 'src/hooks/useApi';
import services from 'src/api/service';
import { useAmzContext } from 'src/contexts/AmzContext';
import { useLocation } from 'react-router-dom';
import useGetWalletDetails from '../../../../../views/pages/dsp-payment/hooks/useGetWalletDetails'
import { usePayloadContext } from 'src/contexts/PayloadContext';
import { isToday } from 'date-fns';
import { replaceString } from 'src/api/demo';

export default function index() {
  
  const { amzState } = useAmzContext();
  const { payloadState } = usePayloadContext()

  const location = useLocation()
  const [anchorEl, setAnchorEl] = useState(null);
  const { dspAccount } = useGetWalletDetails()
    const popoverRef = useRef(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

 

  
  
    const handleOutsideClick = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        handleClose();
      }
    };

  const isPopoverOpen = Boolean(anchorEl);

  const isFlipkart = location?.pathname?.indexOf('/flipkart') > -1;
  const flipkartProfile = JSON.parse(sessionStorage.getItem('flipkartProfile'));
  const isFlipkartV2Profile = isFlipkart && flipkartProfile?.V2 === true;
  const getProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'));
  const currentProfile = isFlipkart ? flipkartProfile : getProfile;
  const doFetchBrandsAccounts = useApi(services.getService);
  const doFetchFlipkartBrandsAccounts = useApi(services.getService);
  const [saveMasterFilters, setSaveMasterFilters] = useState([]);
  const [previewMasterFilters, setPreviewMasterFilters] = useState([]);
  const [listFilters, setListFilters] = useState({});
  const [includeSBSpends, setIncludeSBSpends] = useState(localStorage.getItem("include-sb-spends") == 'yes' ? true : localStorage.getItem("include-sb-spends") == 'no' ? false : true)
  const [showSellerVendorOverlay, setShowSellerVendorOverlay] = useState(false);

  const groupedAccounts = currentProfile?.ams?.groupedAccounts || [];
  const allAccounts = [ currentProfile, ...groupedAccounts ].filter(Boolean);

  sessionStorage.setItem('all-accounts-profiles' , JSON.stringify(allAccounts?.map((item) => {
    return {
      profileId: item?.profileId,
      accountInfo: item?.accountInfo,
      marketingStream: item?.marketingStream
    }
  })))

  useEffect(() => {
   
    if (isPopoverOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isPopoverOpen]);

  useEffect(() => {
    console.log('profilecheck', currentProfile?.profileId);
    if(currentProfile && (currentProfile?.profileId || currentProfile?.agencyProfileId)){
      profileFetchStateRef.current = {
        profileId: currentProfile?.profileId,
        sawLoading: false
      };
      doFetchBrandsAccounts.request({
        url: isFlipkartV2Profile ? '/flipkart-v2/get-group-brand-list' : isFlipkart ? '/flipkart/get-group-brand-list' : '/profiles/get-group-brand-list',
        nodeAPI: 1,
        payload: {}
      });
    }
  }, [currentProfile?.profileId, currentProfile?.agencyProfileId, isFlipkart, isFlipkartV2Profile]);

  const handleClose = () => {
    setSaveMasterFilters([...previewMasterFilters]); 
    setIncludeSBSpends(localStorage.getItem("include-sb-spends") == 'yes' ? true : localStorage.getItem("include-sb-spends") == 'no' ? false : true);
    setShowSellerVendorOverlay(false);
    setAnchorEl(null);
  };

  const isCheckIsToday = useMemo(() => {
    return String(payloadState?.dateRange?.key).toLowerCase() == 'today' || ( isToday(new Date(payloadState?.dateRange?.startDate)) && isToday(new Date(payloadState?.dateRange?.endDate)) )
  }, [payloadState?.dateRange])
  const isSnaphotOrMasterOverview = useMemo(() => {
    return location?.pathname.indexOf('snapshot') > -1 || location?.pathname.indexOf('master-overview') > -1
  }, [location?.pathname], [])
  const isFlipkartSnapshotOrMasterOverview = useMemo(() => {
    return location?.pathname.indexOf('flipkart-snapshot') > -1 || location?.pathname.indexOf('flipkart-master-overview') > -1
  }, [location?.pathname], [])

  const isSQPReport = useMemo(() => {
    return location?.pathname.indexOf('/amazon/search-query-performance') > -1
  }, [location?.pathname])

  const tabsListRef = useRef([])

  // const tabListData = useMemo(() => {

  //   const listTabs = location.pathname.indexOf('/amazon/targeting') > -1  ? [
  //     { eventKey: 'ad_account', title: 'Ad Account', listParam: 'ams', minimumLength: 2, saveParam: 'ams' },
  //   ] : location.pathname.indexOf('/amazon-dsp') > -1 ? [
  //     { eventKey: 'dsp_account', title: 'DSP Account', listParam: 'dsp', minimumLength: 1, saveParam: 'dsp' },
  //   ] : [
  //     { eventKey: 'ad_account', title: 'Ad Account', listParam: 'ams', minimumLength: 2, saveParam: 'ams', ...(isCheckIsToday && isSnaphotOrMasterOverview ? { fieldType: 'radio', minimumLength: 1 } : {}) },
  //     { eventKey: 'brands', title: 'Brands', listParam: 'brands', minimumLength: 1, saveParam: 'brands' },
  //     { eventKey: 'seller', title: 'Seller', listParam: 'seller', minimumLength: 1, saveParam: 'seller' },
  //     { eventKey: 'vendor', title: 'Vendor', listParam: 'vendor', minimumLength: 1, saveParam: 'vendor' },
  //   ]
    
  //   const newTabs = []

  //   for (let i = 0; i < listTabs.length; i++) {
  //     if(listFilters[listTabs[i]?.listParam] && listFilters[listTabs[i]?.listParam].length >= listTabs[i]?.minimumLength) {
  //       newTabs.push(listTabs[i])
  //     }
  //   }

  //   tabsListRef.current = newTabs;

  //   console.log("tabListData", { listTabs, listFilters })

  //   return newTabs

  // }, [listFilters,location.pathname, isCheckIsToday, isSnaphotOrMasterOverview]);

  const [tabListData, setTabListData] = useState([])
  const profileFetchStateRef = useRef({
    profileId: null,
    sawLoading: false
  })


  useEffect(() => {
    const selectedProfile = currentProfile;
    const selectedProfileData = !isFlipkart && amzState?.amazonProfiles
      ? amzState?.amazonProfiles.filter((profile) => profile?.profileId == selectedProfile?.profileId && profile?.datasetId == selectedProfile?.datasetId)
      : [];

    const apiCall = doFetchBrandsAccounts;
    const { loading, data } = apiCall;

    if (!currentProfile?.profileId) return;
    if (profileFetchStateRef.current.profileId != currentProfile?.profileId) return;
    if (loading) {
      profileFetchStateRef.current.sawLoading = true;
      return;
    }
    if (!profileFetchStateRef.current.sawLoading) return;
    if (!loading && data && data?.success == true && data?.result && Object.keys(data?.result).length > 0) {

      const mainAms = [];
      const mainSeller = [];
      const mainVendor = [];
      const response = data?.result;

      const listTabs = location.pathname.indexOf('/amazon/targeting') > -1  ? [
        { eventKey: 'ad_account', title: 'Ad Account', listParam: 'ams', minimumLength: 2, saveParam: 'ams' },
      ] : location.pathname.indexOf('/amazon-dsp') > -1  || location.pathname.indexOf('/billing-payments') > -1 ? [
        { eventKey: 'dsp_account', title: 'DSP Account', listParam: 'dsp', minimumLength: 1, saveParam: 'dsp' },
      ] : isSQPReport ? [
        { eventKey: 'ad_account', title: 'Ad Account', listParam: 'ams', saveParam: 'ams', fieldType: 'radio', minimumLength: 1 },
        { eventKey: 'seller', title: 'Seller', listParam: 'seller', saveParam: 'seller', fieldType: 'radio', minimumLength: 1 }
      ] :
      [
        { eventKey: 'ad_account', title: 'Ad Account', listParam: 'ams', minimumLength: 2, saveParam: 'ams', ...(((isFlipkart && isFlipkartSnapshotOrMasterOverview) || (isCheckIsToday && isSnaphotOrMasterOverview)) ? { fieldType: 'radio', minimumLength: 1 } : {}) },
        { eventKey: 'brands', title: 'Brands', listParam: 'brands', minimumLength: 1, saveParam: 'brands' },
        { eventKey: 'seller', title: 'Seller', listParam: 'seller', minimumLength: 1, saveParam: 'seller' },
        { eventKey: 'vendor', title: 'Vendor', listParam: 'vendor', minimumLength: 1, saveParam: 'vendor' },
      ]
            
      const newListFilters = {
        ams: mainAms?.concat(
          response?.ams
            ? response?.ams?.filter((item) => item.profileId != null && item.accountInfo != null)?.map((item) => {
                return {
                  label: item?.accountInfo?.sortName ? item?.accountInfo?.sortName : item?.accountInfo?.name ? item?.accountInfo?.name : item?.name ? item?.name : item?.accountName ? item?.accountName : '---',
                  value: item?.profileId
                };
              })
            : []
        ),
        dsp:
        selectedProfile
            ? selectedProfile?.dsp && selectedProfile?.dsp?.length > 0
              ? selectedProfile?.dsp
                  ?.filter((item) => item?.dspClientName != null && item?.dspId != null)
                  ?.filter((item, index, arr) => arr.findIndex((i) => String(i?.dspId) === String(item?.dspId)) === index)
                  ?.map((item) => {
                    return {
                      label: item?.dspBrandName ? item?.dspBrandName : item?.dspClientName ? item?.dspClientName : '---',
                      value: item?.dspId
                    };
                  })
              : []
            : [],
        brands:
          [
            ...(response?.brands?.length > 0 ? [ { 
              label: 'Un Assigned',
              value: 'Un Assigned',
              only: true
             } ] : []),
            ...(response?.brands.length > 0 ? response?.brands?.map((item) => {
              return {
                label: item?.label_name,
                value: item?.label_name
              };
            }) : [])
          ],
        seller:
          mainSeller?.concat(
            response?.seller
              ? response?.seller?.map((item) => {
                  return {
                    label: item?.sortName ? item?.sortName : item?.accountName ? item?.accountName : item?.sellerId,
                    value: item?.sellerId
                  };
                })
              : []
          ) || [],
        vendor:
          mainVendor.concat(
            response?.vendor
              ? response?.vendor?.map((item) => {
                  return {
                    label: item?.sortName ? item?.sortName : item?.accountName ? item?.accountName : item?.sellerId,
                    value: item?.sellerId
                  };
                })
              : []
          ) || []
      };
      setListFilters(newListFilters);

      const newTabs = []
  
      for (let i = 0; i < listTabs.length; i++) {
        if(newListFilters[listTabs[i]?.listParam] && newListFilters[listTabs[i]?.listParam].length >= listTabs[i]?.minimumLength) {
          newTabs.push(listTabs[i])
        }
      }

      sessionStorage.setItem('account-filter-tabs', JSON.stringify(newTabs))  

      tabsListRef.current = newTabs;
      setTabListData([...newTabs])


      const getExistingMasterFilters = JSON.parse(sessionStorage.getItem('master-account-filters')) || {};
      const currentProfileId = currentProfile?.profileId;
      const isAdsFail = isCheckIsToday && isSnaphotOrMasterOverview && getExistingMasterFilters?.[currentProfileId]?.some((item) => item?.level == 'ams' && item.keywords.length > 1)
      const isRadio = tabsListRef.current?.some((item) => item?.eventKey == 'ad_account' && item.fieldType == 'radio')
      const isRadioSeller = tabsListRef.current?.some((item) => item?.eventKey == 'seller' && item.fieldType == 'radio')
      console.log("isAdsFail", {getExistingMasterFilters, isAdsFail, isRadio})

      if ((!(getExistingMasterFilters && getExistingMasterFilters[currentProfileId])) || isAdsFail) {
        const newSaveListFilters = [
          {
            level: 'brands',
            keywords: newListFilters?.brands?.map((item) => item.value)
          },
          {
            level: 'ams',
            keywords: (isRadio || isAdsFail) && newListFilters?.ams?.length > 0 ? [newListFilters?.ams[0]].map((item) => item.value) : newListFilters?.ams?.map((item) => item.value),
            level_type: isRadio || isAdsFail ? 'radio' : 'checkbox'
          },
          {
            level: 'dsp',
            keywords: newListFilters?.dsp?.map((item) => item.value)
          },
          {
            level: 'seller',
            keywords: (isRadioSeller) && newListFilters?.seller?.length > 0 ? [newListFilters?.seller[0]].map((item) => item.value) : newListFilters?.seller?.map((item) => item.value),
            level_type: isRadioSeller ? 'radio' : 'checkbox'
          },
          {
            level: 'vendor',
            keywords: newListFilters?.vendor?.map((item) => item.value)
          }
        ]
        setSaveMasterFilters(newSaveListFilters);
        setPreviewMasterFilters(newSaveListFilters);
        if(newSaveListFilters && newSaveListFilters.length > 0) {
            const getExistingMasterFilters = JSON.parse(sessionStorage.getItem('master-account-filters')) || {};
            getExistingMasterFilters[currentProfileId] = newSaveListFilters;
            sessionStorage.setItem('master-account-filters',  JSON.stringify(getExistingMasterFilters))
        }
      } else if (getExistingMasterFilters && getExistingMasterFilters[currentProfileId]) {
        const loaded = getExistingMasterFilters[currentProfileId];
        const normalized = loaded.map((item) => {
          const tabConfig = newTabs.find((t) => t.saveParam === item.level);
          if (tabConfig?.fieldType === 'radio' && item.keywords?.length > 1) {
            return { ...item, keywords: [item.keywords[0]] };
          }
          return item;
        });
        setSaveMasterFilters(normalized);
        setPreviewMasterFilters(normalized);
        const toStore = JSON.parse(sessionStorage.getItem('master-account-filters')) || {};
        toStore[currentProfileId] = normalized;
        sessionStorage.setItem('master-account-filters', JSON.stringify(toStore));
      }
    }
  }, [doFetchBrandsAccounts.loading, doFetchFlipkartBrandsAccounts.loading, isCheckIsToday, isSnaphotOrMasterOverview, location.pathname, isSQPReport, isFlipkartSnapshotOrMasterOverview, isFlipkart, currentProfile?.profileId]);

  const updateSelectedItems = useCallback((event, level, selectItem, is_radio = false) => {
    console.log("updateSelectedItems", { event, level, selectItem, is_radio });
    if(selectItem?.value) {
      const checked = event?.target?.checked
      // At least one of seller or vendor must be selected: block if unchecking would leave both empty
      if ((level === 'seller' || level === 'vendor') && !checked) {
        const sellerKeywords = saveMasterFilters.find((f) => f.level === 'seller')?.keywords || [];
        const vendorKeywords = saveMasterFilters.find((f) => f.level === 'vendor')?.keywords || [];
        const wouldSellerBeEmpty = level === 'seller' ? sellerKeywords.filter((k) => k != selectItem?.value).length === 0 : sellerKeywords.length === 0;
        const wouldVendorBeEmpty = level === 'vendor' ? vendorKeywords.filter((k) => k != selectItem?.value).length === 0 : vendorKeywords.length === 0;
        if (wouldSellerBeEmpty && wouldVendorBeEmpty) {
          setShowSellerVendorOverlay(true);
          setTimeout(() => setShowSellerVendorOverlay(false), 2000);
          return;
        }
      }
      setSaveMasterFilters((prev) => {
        return prev.map((existingItem) => {
          return {
              ...existingItem,
              ...(existingItem.level == level ? {
                  ...(is_radio ? {
                      keywords: checked ? [selectItem.value] : []
                    } : {
                      keywords: checked ? existingItem?.keywords?.concat([selectItem.value]) : existingItem?.keywords.filter((filterItem) => filterItem != selectItem.value)
                    })
              } : {})
          }
        })
      })  
    } else if(event && Array.isArray(event) && event?.length > 0){
      setSaveMasterFilters([...event])
    }
  }, [saveMasterFilters, listFilters])

  const updateInCludeSBSpends = useCallback((event) => {
    setIncludeSBSpends(event.target.checked)
  }, [])

  const handleSubmit = useCallback(() => {
    const getExistingMasterFilters = JSON.parse(sessionStorage.getItem('master-account-filters')) || {};
    if(saveMasterFilters && saveMasterFilters.length > 0) {
        getExistingMasterFilters[currentProfile?.profileId] = saveMasterFilters;
        sessionStorage.setItem('master-account-filters',  JSON.stringify(getExistingMasterFilters))
        setPreviewMasterFilters(saveMasterFilters)
    }
    localStorage.setItem('include-sb-spends', includeSBSpends == true ? 'yes' : 'no')
    window.location.reload()
  }, [saveMasterFilters, includeSBSpends, currentProfile?.profileId])



  const open = Boolean(anchorEl);

  const id = open ? 'simple-popover' : undefined;


  const dspMappedArray = listFilters?.dsp?.length == 1 ? listFilters.dsp : 
  listFilters?.dsp?.filter(filter => dspAccount?.dspId?.includes(filter.value))?.map(filter => ({
    label: filter.label,
    value: filter.value,
  }));

  if(tabListData?.length == 0) {
    return (<></>)
  }

  

  return (
    <React.Fragment>
    <section className="global-filter" onClick={handleClick}>
  <FilterIcon />
  <ul className="global-filter-items">
    {tabListData.map((tabItem, tabIndex) => {

      const selectedItems =
      previewMasterFilters?.find(
        (filterItem) =>
          filterItem.level === tabItem?.saveParam &&
          filterItem?.keywords?.length > 0
      )?.keywords || [];


      if (tabItem.listParam === 'dsp') {
        return (
          <React.Fragment key={`tab--${tabItem?.eventKey}`}>
        {dspMappedArray.length > 0 ? (
          dspMappedArray.map((dspItem, dspIndex) => (
            <React.Fragment key={`dsp--${dspIndex}`}>
              <li>
                <p>{replaceString(dspItem.label)}</p> 
                <span>{dspItem.value}</span>
              </li>
              {tabIndex < tabListData.length - 1 && dspIndex === dspMappedArray.length - 1 && <li> | </li>}
            </React.Fragment>
          ))
        ) : (
          <li>
            No DSP Data: <span>---</span>
          </li>
        )}
      </React.Fragment>
        );
      }

      if (tabItem.listParam === 'ams' && tabItem.fieldType == 'radio') {
        return (
          <React.Fragment key={`tab--${tabItem?.eventKey}`}>
            <li>
              {tabItem?.title}: <span id='is-today-active'>{selectedItems ? allAccounts?.find((item) => String(item.profileId) == String(selectedItems))?.accountInfo?.name : '---'}</span>
            </li>
            {tabIndex < tabListData.length - 1 && <li> | </li>}
          </React.Fragment>
        );
      }

      if (tabItem.listParam === 'seller' && tabItem.fieldType == 'radio') {
        return (
          <React.Fragment key={`tab--${tabItem?.eventKey}`}>
            <li>
              {tabItem?.title}: <span>{selectedItems ? selectedItems?.length : '---'}</span>
            </li>
          </React.Fragment>
        );
      }


      return (
        <React.Fragment key={`tab--${tabItem?.eventKey}`}>
          <li>
            {tabItem?.title}: <span>{selectedItems?.length ? selectedItems?.length : '---'}</span>
          </li>
          {tabIndex < tabListData.length - 1 && <li> | </li>}
        </React.Fragment>
      );
    })}
  </ul>
          {/* <ul className="global-filter-items">
          {!(isAmazonTargeting || isAmazonDsp) && <li>
            Brand:
            <span>{selectedBrandList ? selectedBrandList : '---'}</span>
          </li>}

          {!(isAmazonTargeting || isAmazonDsp) && <li>|</li>}

          {isAmazonTargeting && (
            <li>
              Ad Account:
              <span>{selectedAdAccountList ? selectedAdAccountList : '---'}</span>
            </li>
          )}

          {isAmazonDsp && <li className='f-10'>DSP Account</li>}

          {!(isAmazonTargeting || isAmazonDsp) && <li>|</li>}

          {!(isAmazonTargeting || isAmazonDsp) && <li>
            Seller:
            <span>{selectedSellerList ? selectedSellerList : '---'}</span>
          </li>}

          {!(isAmazonTargeting || isAmazonDsp) && <li>|</li>}

          {!(isAmazonTargeting || isAmazonDsp) && <li>
            Vendor:
            <span>{selectedVendorList ? selectedVendorList : '---'}</span>
          </li>}
        </ul> */}
        {/* <DArrow /> */}
        <DownChevron className="dropdown-down-chevron" data-active={Boolean(anchorEl)} width={10} height={10} colour="#8F8F91" />
      </section>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        PaperProps={{
          style: {
            marginTop: '15px',
            backgroundColor: '#fff',
            borderRadius: '8px',
            boxShadow: '0px 4px 15px 0px #00000026'
          }
        }}
        ref={popoverRef} 
      >
        <div className="global-filter-tabs nav-account-filter">
          <Tabs
            closePopover={handleClose}
            doFetchBrandsAccounts={isFlipkart ? doFetchFlipkartBrandsAccounts : doFetchBrandsAccounts}
            handleSubmit={handleSubmit}
            tabListData={tabListData}
            updateSelectedItems={updateSelectedItems}
            listFilters={listFilters}
            saveMasterFilters={saveMasterFilters}
            updateInCludeSBSpends={updateInCludeSBSpends}
            includeSBSpends={includeSBSpends}
            setIncludeSBSpends={setIncludeSBSpends}
            previewMasterFilters={previewMasterFilters}
            showSellerVendorOverlay={showSellerVendorOverlay}
          />
        </div>
      </Popover>
    </React.Fragment>
  );
}
